function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from 'react';
import { T, useTranslate } from 'shared/helper/translate';
import { price } from 'researcher/helpers/price';
export var prepaymentValid = function prepaymentValid(usdPrepaymentApplied, prepaymentOption, maximumApplicableUsdPrepaymentBalance) {
  if (prepaymentOption === 'none' && usdPrepaymentApplied > 0) {
    return false;
  }
  return usdPrepaymentApplied <= maximumApplicableUsdPrepaymentBalance;
};
var PartialPrepayment = function PartialPrepayment(_ref) {
  var currency = _ref.currency,
    maximumApplicableUsdPrepaymentBalance = _ref.maximumApplicableUsdPrepaymentBalance,
    prepaymentOption = _ref.prepaymentOption,
    updatePrepaymentApplied = _ref.updatePrepaymentApplied;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    partialPrepaymentValue = _useState2[0],
    setPartialPrepaymentValue = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    error = _useState4[0],
    setError = _useState4[1];
  var calculateValidatedAmount = function calculateValidatedAmount(amount) {
    var partialPrepaymentAmount = parseFloat(amount);
    var usdPartialPrepaymentAmount = partialPrepaymentAmount / currency.exchangeRate;

    // If this is not a number, or exceeds the max, return null
    if (Number.isNaN(partialPrepaymentAmount) || parseFloat(usdPartialPrepaymentAmount.toFixed(2)) > maximumApplicableUsdPrepaymentBalance) {
      return null;
    }
    return partialPrepaymentAmount;
  };
  var updatePartialPrepaymentValue = function updatePartialPrepaymentValue(e) {
    setPartialPrepaymentValue(e.target.value);
    setError(false);
    var validatedAmount = calculateValidatedAmount(e.target.value);
    if (validatedAmount === null) {
      setError(true);
    } else {
      updatePrepaymentApplied(validatedAmount / currency.exchangeRate);
    }
  };
  useEffect(function () {
    if (prepaymentOption === 'partialPayment') {
      updatePrepaymentApplied(partialPrepaymentValue);
    }
  }, [prepaymentOption]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(T.md, {
    inline: true,
    source: "Pay for part of this order with prepay"
  }), prepaymentOption === 'partialPayment' ? /*#__PURE__*/React.createElement("input", {
    className: "form-control",
    onChange: updatePartialPrepaymentValue,
    value: partialPrepaymentValue,
    placeholder: t('Enter your prepay amount (%(currency)s)', {
      currency: currency.isoCode
    })
  }) : null, error && prepaymentOption === 'partialPayment' ? /*#__PURE__*/React.createElement("em", {
    className: "error"
  }, /*#__PURE__*/React.createElement(T.md, {
    inline: true,
    source: "Prepay amount cannot exceed %(amount)s",
    params: {
      amount: price(currency, maximumApplicableUsdPrepaymentBalance, true, true)
    }
  })) : null);
};
export default PartialPrepayment;